import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { getErrorObjFormat } from "../../../helpers/errorObjFormat";

const dashboardUrl = process.env.REACT_APP_API_BASE_URL + "/v1/dashboard";

const initialState = {
  data: null,
  isLoading: false,
  error: null,
};

const dashboard = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    fetchDashboardStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    fetchDashboardSuccess(state, { payload }) {
      state.data = payload;
      state.isLoading = false;
    },
    fetchDashboardFailure(state, { payload }) {
      state.isLoading = false;
      state.error = payload;
    },
  },
});

export const {
  fetchDashboardStart,
  fetchDashboardSuccess,
  fetchDashboardFailure,
} = dashboard.actions;

export default dashboard.reducer;

// from/to are YYYY-MM-DD business dates; type is "all" | "package" | "condo".
export const fetchDashboard =
  ({ from, to, type = "all" } = {}) =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchDashboardStart());
      const res = await axios.get(dashboardUrl, {
        params: { from, to, type },
        headers: { Authorization: `Bearer ${getState().auth.token}` },
      });
      dispatch(fetchDashboardSuccess(res.data.response));
    } catch (err) {
      dispatch(fetchDashboardFailure(getErrorObjFormat(err)));
    }
  };
